export default __webpack_public_path__ + "static/media/937.088d23dc.png";